<template>
  <WidgetWrapper>
    <WidgetTitle
      v-if="!loading"
      :title="$t('main.marketingChannels.title')"
      :description="$t('main.marketingChannels.description')"
    >
      <template v-slot:dropDown>
        <div class="d-flex">
          <Date
            :actualDate="marketingChannels.actualDate"
            :options="{ showFullDate: false, oldCalendar: true }"
          />
          <!-- на мобилке пикер стоит в одном ряду с выбором домена (см. TableView) -->
          <div class="d-none d-md-block">
            <ValuePicker class="value_picker" v-model="value_type" />
          </div>
          <!-- <div @click="onModalOpen()">
            <DynamicButton />
          </div> -->
        </div>
      </template>
    </WidgetTitle>
    <div v-if="isData" class="content" ref="content">
      <TableView
        :channelsInfo="channelsInfo"
        :valueHandler="getValue"
        :value_type="value_type"
        :dataset="datasetOnActualDate"
        :actualDate="marketingChannels.actualDate"
        :platforms="marketingChannels.platforms"
      >
        <template v-slot:mobileControls>
          <ValuePicker v-model="value_type" />
        </template>
      </TableView>
    </div>
    <Modal
      type="table"
      :closeHandler="close => (isModalOpen = false)"
      :isOpen="isModalOpen"
    >
      <template v-slot:title>
        {{ $t('main.marketingChannels.title') }}
      </template>
      <template v-slot:body>
        <DynamicMarketingChannels :channelsInfo="channelsInfo" />
      </template>
    </Modal>
    <WidgetError v-if="!isData && !loading" />
    <SkeletonLoading v-if="loading" name="marketingChannels" />
  </WidgetWrapper>
</template>

<script>
import WidgetTitle from '@/components/widgets/widgets-helpers/WidgetTitle.vue'
import Modal from '@/components/modals/Modal.vue'
import SkeletonLoading from '@/components/SkeletonLoading.vue'
import WidgetError from '@/components/errors/WidgetError.vue'
import WidgetWrapper from '@/components/widgets/widgets-helpers/WidgetWrapper.vue'
import DynamicMarketingChannels from '@/components/widgets/marketing-channels/dynamic/DynamicMarketingChannels.vue'
import { mapGetters, mapState } from 'vuex'
import SocialIcon from '@/assets/icons/marketing-channels/Social.svg'
import AdNetworksIcon from '@/assets/icons/marketing-channels/AdNetworks.svg'
import MailIcon from '@/assets/icons/marketing-channels/Mail.svg'
import ReferralsIcon from '@/assets/icons/marketing-channels/Referrals.svg'
import SearchIcon from '@/assets/icons/marketing-channels/Search.svg'
import DirectIcon from '@/assets/icons/marketing-channels/Direct.svg'
import GenAiIcon from '@/assets/icons/marketing-channels/GenAi.svg'
import AffiliateIcon from '@/assets/icons/marketing-channels/Affiliate.svg'
import getValue from '@/helpers/processing/getValue'
import getColor from '@/helpers/store/getColor'
import nFormatter from '@/helpers/processing/nFormatter'
import getChannelSortIndex from '@/helpers/store/getChannelSortIndex'
import DynamicButton from '@/components/buttons/DynamicButton.vue'
import Date from '@/components/shared/Date.vue'
import TableView from './TableView.vue'
import ValuePicker from './ValuePicker.vue'

export default {
  data() {
    return {
      value_type: 'percent',
      isModalOpen: false,
    }
  },
  components: {
    WidgetTitle,
    TableView,
    SkeletonLoading,
    WidgetError,
    WidgetWrapper,
    ValuePicker,
    DynamicMarketingChannels,
    DynamicButton,
    Modal,
    Date,
  },
  computed: {
    // computed so titles re-translate on locale change
    channelsInfo() {
      return {
        Direct: {
          title: this.$t('main.marketingChannels.direct.title'),
          icon: DirectIcon,
          hintName: 'metric-direct',
          hintTitle: this.$t('faq.metric-direct'),
        },
        Search: {
          title: this.$t('main.marketingChannels.search.title'),
          icon: SearchIcon,
          hintName: 'metric-search',
          hintTitle: this.$t('faq.metric-search'),
        },
        Referrals: {
          title: this.$t('main.marketingChannels.referrals.title'),
          icon: ReferralsIcon,
          hintName: 'metric-referral-sites',
          hintTitle: this.$t('faq.metric-referral-sites'),
        },
        Social: {
          title: this.$t('main.marketingChannels.social.title'),
          icon: SocialIcon,
          hintName: 'metric-social-media',
          hintTitle: this.$t('faq.metric-social-media'),
        },
        'Paid Referrals': {
          title: this.$t('main.marketingChannels.paidReferrals.title'),
          icon: AdNetworksIcon,
          hintName: 'metric-display-ads',
          hintTitle: this.$t('faq.metric-display-ads'),
        },
        Mail: {
          title: this.$t('main.marketingChannels.mail.title'),
          icon: MailIcon,
          hintName: 'metric-email',
          hintTitle: this.$t('faq.metric-email'),
        },
        GenAi: {
          title: this.$t('main.marketingChannels.genAi.title'),
          icon: GenAiIcon,
          hintName: 'metric-gen-ai',
          hintTitle: this.$t('faq.metric-gen-ai'),
        },
        Affiliate: {
          title: this.$t('main.marketingChannels.affiliate.title'),
          icon: AffiliateIcon,
          hintName: 'metric-affiliate',
          hintTitle: this.$t('faq.metric-affiliate'),
        },
      }
    },
    ...mapGetters('marketingChannels', ['datasetOnActualDate']),
    ...mapState('mainData', {
      mainData: state => state,
    }),
    ...mapState('marketingChannels', {
      marketingChannels: state => state,
    }),
    isData() {
      return (
        !this.loading &&
        !this.mainData.error.status &&
        this.datasetOnActualDate.length
      )
    },
    loading() {
      // return true
      return this.mainData.loading
    },
  },
  methods: {
    getValue,
    getColor,
    getChannelSortIndex,
    nFormatter,
    onModalOpen() {
      this.isModalOpen = true
    },
  },
}
</script>

<style scoped>
.value_picker {
  margin-right: 20px;
}
</style>
